import {NgModule} from "@angular/core";
import {MatDividerModule} from "@angular/material/divider";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {TranslateModule} from '@ngx-translate/core';
import {PreviewAlerteModule} from "@share/component/alerte/preview-alerte.module";
import {LoginService} from "@share/login/login.service";
import {ShareModule} from "@share/share.module";
import {ProfilService} from "../../../profil/profil.service";
import {MatLegacyRadioModule as MatRadioModule} from "@angular/material/legacy-radio";
import {DroitAdmin} from "@core/security/droit-admin";
import {ReleveFactureModule} from "@components/facture/releve-facture.module";
import {NdfComponent} from "./ndf/ndf.component";
import {NdfFraisCartesComponent} from "./frais-cartes/ndf-frais-cartes.component";
import {FraisNdfComponent} from "./frais-ndf.component";
import {NDFModule} from "@components/ndf/ndf.module";
import {SuiviRelevesComponent} from "@components/admin/frais/ndf/suivi-releves/suivi-releves.component";
import {ParamsCartesService} from "@services/admin/frais/params-cartes.service";
import {SuiviReleveServiceHttp} from "@services/admin/ca/suivi-releve-service-http.service";
import {SuiviReleveListeComponent} from "@components/admin/frais/ndf/suivi-releves/suivi-releve-liste.component";
import {SuiviReleveListItemComponent} from "@components/admin/frais/ndf/suivi-releves/suivi-releve-list-item.component";
import {SuiviReleveService} from "@components/admin/frais/ndf/suivi-releves/suivi-releve.service";
import {SuiviReleveHistoryItemComponent} from "@components/admin/frais/ndf/suivi-releves/suivi-releve-history-item.component";
import {SuiviReleveErrorDetailComponent} from "@components/admin/frais/ndf/suivi-releves/suivi-releve-error-detail.component";
import {SuiviReleveErrorListItemComponent} from "@components/admin/frais/ndf/suivi-releves/suivi-releve-error-list-item.component";
import {SuiviReleveErrorListeComponent} from "@components/admin/frais/ndf/suivi-releves/suivi-releve-error-liste.component";
import {MatLegacyDialogModule as MatDialogModule} from "@angular/material/legacy-dialog";

export const fraisNdfRoutes : Routes = [
    {
        path: 'Ndf',
        component: NdfComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_VISUALISATION_NDF] }
    }, {
        path: 'FraisCartes',
        component: NdfFraisCartesComponent,
        canActivate: [AdminGuardProvider]
    }, {
        path: 'SuiviReleves',
        component: SuiviRelevesComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_GESTION_FRAIS_CARTE] }
    }, {
        path: 'SuiviReleves/:idLot',
        component: SuiviReleveErrorListeComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_GESTION_FRAIS_CARTE] }
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Ndf'
    }, {
        path: '**',
        redirectTo: 'Ndf'
    }
];

@NgModule({
    imports: [ShareModule, PreviewAlerteModule, MatDividerModule, TranslateModule, MatRadioModule, ReleveFactureModule, NDFModule, MatDialogModule],
    declarations: [
        FraisNdfComponent, NdfComponent, NdfFraisCartesComponent, SuiviRelevesComponent, SuiviReleveListeComponent, SuiviReleveListItemComponent, SuiviReleveHistoryItemComponent, SuiviReleveErrorListeComponent, SuiviReleveErrorListItemComponent, SuiviReleveErrorDetailComponent
    ],
    exports: [
        NdfComponent, NdfFraisCartesComponent, SuiviRelevesComponent
    ],
    providers: [ProfilService, LoginService, ParamsCartesService, SuiviReleveServiceHttp, SuiviReleveService]
})
export class FraisNdfModule {
}
